import React from "react";
import ProfileIcon from "../login/ProfileIcon";
import { useUser } from "./UserContext";
import CtaButton from "../ui/CtaButton";

interface AuthenticationButtonProps {
  onLogout: () => void;
  toggleModal: () => void;
}

const AuthenticationButton: React.FC<AuthenticationButtonProps> = ({
  onLogout,
}) => {
  const { user, authReady } = useUser();
  const isAuthenticated = !!user && user.id !== 0;

  if (!authReady) {
    return (
      <span style={{ minWidth: "80px", display: "inline-flex", alignItems: "center" }} />
    );
  }

  return (
    <span style={{ display: "inline-flex", alignItems: "center" }}>
      {isAuthenticated ? (
        <ProfileIcon onSignOut={onLogout} />
      ) : (
        <CtaButton
          href="/pricing"
          glassClassName="auth-cta-button"
          className="auth-cta-button__inner"
        >
          Try for free
        </CtaButton>
      )}
    </span>
  );
};

export default AuthenticationButton;
